import script from "./AgendaSessionSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaSessionSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./AgendaSessionSkeleton.vue?vue&type=style&index=0&id=3adce67d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3adce67d"]])

export default __exports__